CustomTC.define('modules/comments/comments',['modules/util', 'modules/core', 'modules/config', 'modules/constants', 'modules/options', 'modules/load-data', 'modules/language', 'text!modules/htmls/loading.html', 'text!modules/comments/htmls/comment.html', 'css!modules/css/loading', 'css!modules/comments/css/comment'], function(util, core, config, constants, options, loadData, language, loading, comment) {
    return {
        endOfComment: 0,
        offsetVal: 0,
        limitVal: 10,
        totalComments: 0,
        //init
        init: function(playerUI, video, isAjaxAllowed) {
            var video = options.videoInfo[0];
            var self = this;
            this.playerUI = playerUI;
            var commentContainer = core.init(comment);
            commentContainer.find('.' + constants.CSS_TOUCHCAST_COMMENTS_LOADING_CONTAINER + '').html(loading);
            core.init('body').find('.' + constants.CSS_TOUCHCAST_PLAYER_CONTAINER + '').append(commentContainer);

            var ieVer = util.getIEVersion();
            if (ieVer !== undefined && parseInt(ieVer) > 0) {
                this.ieFixes(ieVer);
            }
            if (TouchCast.InteractiveLayer.getHLSInfo() !== '') {
                core.hide(core.init('#' + constants.CSS_TOUCHCAST_COMMENT_FORM + ''));
            }
            //this.updateCommentCount(options.getUser() ? options.getUser().getTotalComments() : '0');
            //this.setTotalComments(options.getUser() ? options.getUser().getTotalComments() : '0');
            var commentsWrapper = core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_WRAPPER + '');
            var commentIcon = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_COMMENT + '');
            core.off(commentIcon, 'touchstart click');
            core.on(commentIcon, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (core.hasClass(commentsWrapper, constants.CSS_TOUCHCAST_HIDE))
                    self.showCommentsPopup(commentsWrapper, video, isAjaxAllowed);
                else
                    self.hideCommentsPopup(commentsWrapper, video, isAjaxAllowed);
            });

            var commentsContainer = core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_CONTAINER + '');
            core.off(commentsContainer, 'scrollstart scroll');
            core.on(commentsContainer, 'scrollstart scroll', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var scrollValue = core.scrollTop(core.init(this));
                var commentAreaH = core.outerHeight(core.init(this));
                var totalH = core.getHeight(core.init('.' + constants.CSS_TOUCHCAST_COMMENT_ITEMS + ''));
                var checkVal = totalH - commentAreaH + 16; //( 8+8 padding)
                if (util.getIEVersion() < 10)
                    checkVal = totalH - commentAreaH + 8;

                if (scrollValue === checkVal && self.getEndOfComment() === 0 && (isAjaxAllowed === 1 || TouchCast.InteractiveLayer.getHLSInfo() !== '')) {
                    core.addClass(commentsWrapper, constants.CSS_TOUCHCAST_LOADING);
                    loadData.getPerformanceComments(video.id, self.getOffsetVal(), self.getLimitVal(), function(data) {
                        self.processCommentsData(data);
                    });
                    options.setFirstTimeLoad(1);
                    self.setOffsetVal(parseInt(self.getOffsetVal()) + parseInt(self.getLimitVal()));
                }
                return false;
            });

            var commentForm = core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_WRAPPER + ' form');
            core.off(commentForm, 'submit');
            core.on(commentForm, 'submit', function(e) {
                e.stopImmediatePropagation();
                self.postComment(playerUI, video, isAjaxAllowed);
                return false;
            });

            var commentPostBtn = core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_WRAPPER + ' form > span');
            core.off(commentPostBtn, 'touchstart click');
            core.on(commentPostBtn, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                self.postComment(playerUI, video, isAjaxAllowed);
                return false;
            });
        },
        ieFixes: function(ver) {
            if (ver < 10) {
                core.setCss(core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_LOADING_CONTAINER + ' .' + constants.CSS_TOUCHCAST_LOADING_SPINNER + ''), {
                    color: options.getSkinColor()
                });
            }
        },
        clearComments: function() {
            var commentsWrapper = core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_WRAPPER + '');
            core.remove(commentsWrapper);
            /*var commentItems = core.init('.' + constants.CSS_TOUCHCAST_COMMENT_ITEMS + '');
            core.html(commentItems, '');*/
            this.setOffsetVal(0);

        },
        postComment: function(playerUI, video, isAjaxAllowed) {
            var video = options.videoInfo[0];
            var self = this;
            var commentsWrapper = core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_WRAPPER + '');
            var commentPostBtn = core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_WRAPPER + ' form > span');
            var commentInput = core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_WRAPPER + ' form input');
            var commentText = core.trim(core.getVal(commentInput));
            if (commentText === '' || core.hasClass(commentPostBtn, constants.CSS_TOUCHCAST_DISABLE))
                return false;
            core.trigger(commentInput, 'blur');
            if (options.getApiUrl() === '' || !options.getApiUrl()) {
                var loginUrl = video.url;
            } else {
                // login url
                var redirectUrl = video.url.replace(config.domain, '');
                var redirectUrl = redirectUrl.replace('http://', '');
                var redirectUrl = redirectUrl.replace('https://', '');
                var redirectUrl = redirectUrl.replace('http:', '');
                var loginUrl = config.domain + '/login?redirect=' + redirectUrl
            }
            if (playerUI.preChecksForAjaxCall(language.getVideoCommentPopupMsg(), loginUrl)) {
                if (!isAjaxAllowed)
                    return false;
                core.addClass(commentsWrapper, constants.CSS_TOUCHCAST_LOADING);
                core.setVal(commentInput, '');
                core.addClass(commentPostBtn, constants.CSS_TOUCHCAST_DISABLE);
                core.scrollTop(core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_CONTAINER + ''), 0);
                var commentIconCount = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_COMMENT + ' i');
                var totalComments = self.getTotalComments();
                var commentItems = core.init('.' + constants.CSS_TOUCHCAST_COMMENT_ITEMS + '');
                var commentDivider = '<div class="' + constants.CSS_TOUCHCAST_COMMENT_DIVIDER + '"></div>';
                var video = options.videoInfo[0];
                loadData.postPerformanceComment(options.getUser().getPostName(), commentText, video.id, function(data) {
                    if (options.getApiUrl() === '' || !options.getApiUrl()) {
                        if (data.comment_id) {
                            var commentNode = self.getCommentNode(data);
                            if (totalComments >= 1) {
                                core.prepend(commentItems, commentDivider);
                                core.prepend(commentItems, commentNode);
                            } else
                                core.html(commentItems, commentNode);
                            core.html(commentIconCount, totalComments + 1);
                        }
                    } else {
                        var commentNode = self.getCommentNode(data.response.comment);
                        if (totalComments >= 1) {
                            core.prepend(commentItems, commentDivider);
                            core.prepend(commentItems, commentNode);
                        } else
                            core.html(commentItems, commentNode);
                        core.html(commentIconCount, totalComments + 1);
                    }
                    core.removeClass(commentsWrapper, constants.CSS_TOUCHCAST_LOADING);
                    core.removeClass(commentPostBtn, constants.CSS_TOUCHCAST_DISABLE);
                    self.setTotalComments(totalComments + 1);
                });
            }
        },
        updateCommentCount: function(value) {
            var commentIconCount = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_COMMENT + ' i');
            if (parseInt(value) > 0) {
                core.html(commentIconCount, value);
            }
        },
        getCommentNode: function(item) {
            if (TouchCast.InteractiveLayer.getHLSInfo() !== '') {
                var commentItem = core.init('<div class="' + constants.CSS_TOUCHCAST_COMMENT_ITEM + '"></div>');
                var commentAvatar = core.init('<div class="' + constants.CSS_TOUCHCAST_COMMENT_AVATAR + '"></div>');
                var commentContent = core.init('<div class="' + constants.CSS_TOUCHCAST_COMMENT_CONTENT + '"></div>');
                var commentUsername = core.init('<span class="' + constants.CSS_TOUCHCAST_COMMENT_USERNAME + '"></span>');
                var commentText = core.init('<span class="' + constants.CSS_TOUCHCAST_COMMENT_TEXT + '"></span>');
                var commentTime = core.init('<div class="' + constants.CSS_TOUCHCAST_COMMENT_TIME + '"></div>');
                var avatarLink = core.init('<a target="_self"></a>');
                core.setAttr(avatarLink, 'href', '#');
                var userLink = core.clone(avatarLink);
                var avatarImg = core.init('<img />');
                core.setAttr(avatarImg, 'src', config.defaultAvatar);
                core.setAttr(avatarImg, 'alt', item.username);
                core.html(commentUsername, item.username + ' ');
                core.append(avatarLink, avatarImg);
                core.append(commentAvatar, avatarLink);
                core.append(userLink, commentUsername);
                core.html(commentText, item.comment);
                core.html(commentTime, util.timeAgo(item.created));
                core.append(commentContent, userLink);
                core.append(commentContent, commentText);
                core.append(commentItem, commentAvatar);
                core.append(commentItem, commentContent);
                core.append(commentItem, commentTime);
                return commentItem;
            } else {
                if (options.getApiUrl() === '' || !options.getApiUrl()) {
                    var commentItem = core.init('<div class="' + constants.CSS_TOUCHCAST_COMMENT_ITEM + '"></div>');
                    var commentAvatar = core.init('<div class="' + constants.CSS_TOUCHCAST_COMMENT_AVATAR + '"></div>');
                    var commentContent = core.init('<div class="' + constants.CSS_TOUCHCAST_COMMENT_CONTENT + '"></div>');
                    var commentUsername = core.init('<span class="' + constants.CSS_TOUCHCAST_COMMENT_USERNAME + '"></span>');
                    var commentText = core.init('<span class="' + constants.CSS_TOUCHCAST_COMMENT_TEXT + '"></span>');
                    var commentTime = core.init('<div class="' + constants.CSS_TOUCHCAST_COMMENT_TIME + '"></div>');
                    var avatarLink = core.init('<a target="_self"></a>');
                    core.setAttr(avatarLink, 'href', item.tc_profile_url);
                    var userLink = core.clone(avatarLink);
                    var avatarImg = core.init('<img />');
                    core.setAttr(avatarImg, 'src', item.avatar_url);
                    core.setAttr(avatarImg, 'alt', item.display_name);
                    core.html(commentUsername, item.display_name + ' ');
                    core.append(avatarLink, avatarImg);
                    core.append(commentAvatar, avatarLink);
                    core.append(userLink, commentUsername);
                    core.html(commentText, item.comment_text);
                    core.html(commentTime, util.timeAgo(item.date_creation));
                    core.append(commentContent, userLink);
                    core.append(commentContent, commentText);
                    core.append(commentItem, commentAvatar);
                    core.append(commentItem, commentContent);
                    core.append(commentItem, commentTime);
                    return commentItem;
                } else {
                    var commentItem = core.init('<div class="' + constants.CSS_TOUCHCAST_COMMENT_ITEM + '"></div>');
                    var commentAvatar = core.init('<div class="' + constants.CSS_TOUCHCAST_COMMENT_AVATAR + '"></div>');
                    var commentContent = core.init('<div class="' + constants.CSS_TOUCHCAST_COMMENT_CONTENT + '"></div>');
                    var commentUsername = core.init('<span class="' + constants.CSS_TOUCHCAST_COMMENT_USERNAME + '"></span>');
                    var commentText = core.init('<span class="' + constants.CSS_TOUCHCAST_COMMENT_TEXT + '"></span>');
                    var commentTime = core.init('<div class="' + constants.CSS_TOUCHCAST_COMMENT_TIME + '"></div>');
                    var avatarLink = core.init('<a target="_self"></a>');
                    core.setAttr(avatarLink, 'href', item.author.homepage);
                    var userLink = core.clone(avatarLink);
                    var avatarImg = core.init('<img />');
                    if (item.author.image_url && item.author.image_url !== '') {
                        core.setAttr(avatarImg, 'src', item.author.image_url);

                    } else {
                        core.setAttr(avatarImg, 'src', config.defaultAvatar);
                    }
                    core.setAttr(avatarImg, 'alt', item.author._attrs.name);
                    core.html(commentUsername, item.author._attrs.name + ' ');
                    core.append(avatarLink, avatarImg);
                    core.append(commentAvatar, avatarLink);
                    core.append(userLink, commentUsername);
                    core.html(commentText, item.text);
                    core.html(commentTime, util.timeAgo(item.date_creation));
                    core.append(commentContent, userLink);
                    core.append(commentContent, commentText);
                    core.append(commentItem, commentAvatar);
                    core.append(commentItem, commentContent);
                    core.append(commentItem, commentTime);
                    return commentItem;
                }
            }
        },
        processCommentsData: function(data) {
            var self = this;
            console.log(data.response.comments, 'new');
            var commentsWrapper = core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_WRAPPER + '');
            var commentItems = core.init('.' + constants.CSS_TOUCHCAST_COMMENT_ITEMS + '');
            var commentDivider = '<div class="' + constants.CSS_TOUCHCAST_COMMENT_DIVIDER + '"></div>';
            if (options.getFirstTimeLoad() === 0)
                core.html(core.init('.' + constants.CSS_TOUCHCAST_COMMENT_ITEMS + ''), '');
            if (TouchCast.InteractiveLayer.getHLSInfo() !== '') {
                if (data.response.comments._attrs.total_page > 0) {
                    if (data.response.comments._attrs.total > 0) {
                        self.setTotalComments(data.response.comments._attrs.total);
                        for(var i in data.response.comments) {
                            if (i == 'comment') {
                                core.append(commentItems, self.getCommentNode(data.response.comments[i]));
                            }
                            if (i >= 0 && i < data.response.comments._attrs.total - 1)
                                core.append(commentItems, commentDivider);
                        };
                    } else if (options.getFirstTimeLoad() === 0) {
                        var noComments = core.init('<div></div>');
                        core.addClass(noComments, constants.CSS_TOUCHCAST_NO_COMMENTS);
                        if (util.getIEVersion() === 8)
                            core.addClass(noComments, 'ie8');
                        core.html(noComments, language.getCommentPopupNoCommentsText());
                        core.html(commentItems, noComments);
                    }
                } else {
                    this.setEndOfComment(1);
                    this.setOffsetVal(0);
                }
            } else {
                if (options.getApiUrl() === '' || !options.getApiUrl()) {
                    if (data.count > 0) {
                        if (data.total_comments > 0) {
                            self.setTotalComments(data.total_comments);
                            core.each(data, function(i) {
                                if (data[i].inappropriate !== 0)
                                    return true; // continue
                                core.append(commentItems, self.getCommentNode(data[i]));
                                if (i >= 0 && i < data.total_comments - 1)
                                    core.append(commentItems, commentDivider);
                            });
                        } else if (options.getFirstTimeLoad() === 0) {
                            var noComments = core.init('<div></div>');
                            core.addClass(noComments, constants.CSS_TOUCHCAST_NO_COMMENTS);
                            if (util.getIEVersion() === 8)
                                core.addClass(noComments, 'ie8');
                            core.html(noComments, language.getCommentPopupNoCommentsText());
                            core.html(commentItems, noComments);
                        }
                    } else {
                        this.setEndOfComment(1);
                        this.setOffsetVal(0);
                    }
                } else {
                    if (data.response.performance_comments._attrs.count > 0) {
                        if (data.response.performance_comments._attrs.total > 0) {
                            self.setTotalComments(data.response.performance_comments._attrs.total);
                            if (data.response.performance_comments._attrs.total === 1) {
                                if (data.response.performance_comments.comment.inappropriate === 0) {
                                    core.append(commentItems, self.getCommentNode(data.response.performance_comments.comment));
                                }
                            } else {
                                core.each(data.response.performance_comments.comment, function(i) {
                                    if (data.response.performance_comments.comment[i].inappropriate !== 0)
                                        return true; // continue
                                    core.append(commentItems, self.getCommentNode(data.response.performance_comments.comment[i]));
                                    if (i >= 0 && i < data.response.performance_comments._attrs.total - 1)
                                        core.append(commentItems, commentDivider);
                                });
                            }
                        } else if (options.getFirstTimeLoad() === 0) {
                            var noComments = core.init('<div></div>');
                            core.addClass(noComments, constants.CSS_TOUCHCAST_NO_COMMENTS);
                            if (util.getIEVersion() === 8)
                                core.addClass(noComments, 'ie8');
                            core.html(noComments, language.getCommentPopupNoCommentsText());
                            core.html(commentItems, noComments);
                        }
                    } else {
                        this.setEndOfComment(1);
                        this.setOffsetVal(0);
                    }
                }
            }
            options.setFirstTimeLoad(1);
            core.removeClass(commentsWrapper, constants.CSS_TOUCHCAST_LOADING);
        },
        showCommentsPopup: function(commentsWrapper, video, isAjaxAllowed) {
            var video = options.videoInfo[0];
            var self = this;
            var commentIcon = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_COMMENT + '');
            this.playerUI.clearControlSelections();
            core.removeClass(commentsWrapper, constants.CSS_TOUCHCAST_HIDE);
            core.addClass(commentIcon, constants.CSS_TOUCHCAST_SELECTED);
            core.tooltipster(commentIcon, 'disable');

            if (options.getFirstTimeLoad() === 0 && (isAjaxAllowed === 1 || TouchCast.InteractiveLayer.getHLSInfo() !== '')) {
                core.addClass(commentsWrapper, constants.CSS_TOUCHCAST_LOADING);
                loadData.getPerformanceComments(video.id, this.getOffsetVal(), this.getLimitVal(), function(data) {
                    self.processCommentsData(data);
                });
                options.setFirstTimeLoad(1);
                this.setOffsetVal(parseInt(this.getOffsetVal()) + parseInt(this.getLimitVal()));
            }

            var commentInput = core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_WRAPPER + ' form input[type=text]');
            core.off(commentInput, 'touchstart');
            core.on(commentInput, 'touchstart', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                core.trigger(core.init(this), 'focus');
                return false;
            });

            core.off(commentInput, 'keyup');
            core.on(commentInput, 'keyup', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
            });
        },
        hideCommentsPopup: function(commentsWrapper) {
            var commentIcon = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_COMMENT + '');
            var commentInput = core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_WRAPPER + ' form input');
            core.trigger(commentInput, 'blur');
            core.addClass(commentsWrapper, constants.CSS_TOUCHCAST_HIDE);
            core.removeClass(commentIcon, constants.CSS_TOUCHCAST_SELECTED);
            core.tooltipster(commentIcon, 'enable');
        },
        //get end of comment
        getEndOfComment: function() {
            return this.endOfComment;
        },
        //set end of comment
        setEndOfComment: function(val) {
            this.endOfComment = val;
        },
        //get offset value
        getOffsetVal: function() {
            return this.offsetVal;
        },
        //set offset value
        setOffsetVal: function(val) {
            this.offsetVal = val;
        },
        //get offset value
        getLimitVal: function() {
            return this.limitVal;
        },
        //set offset value
        setLimitVal: function(val) {
            this.limitVal = val;
        },
        // set total comments
        setTotalComments: function(val) {
            this.totalComments = val;
        },
        // get total comments
        getTotalComments: function() {
            return this.totalComments;
        }
    };
});

